import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import * as moment from 'moment';

import { AcuityDetails } from '../models/acuity-details.model';
import { AcuityRoomDetails } from '../models/acuity-room-details.model';
import { AcuityService } from './acuity.service';
import { ConfigService } from './config.service';
import { CostCenter } from 'src/shared/models/cost-center.model';
import { CostCenterService } from './cost-center.service';
import { PatientCensusRecord } from '../models/patient-census-record.model';
import { ShiftBlock } from '../models/shift-block.model';
import { ShiftBlockService } from './shift-block.service';
import { ShiftRecord } from 'src/shared/models/shift-record.model';
import { ShiftRecordServiceBase } from './shift-record-base.service';
import { WorkflowPageUtil } from 'src/app/workflow/base-classes/workflow-page/workflow-page.util';

@Injectable({
    providedIn: 'root'
})
export class AcuityShiftRecordService extends ShiftRecordServiceBase {

    constructor(
      protected _configService: ConfigService,
      protected _http: HttpClient,
      protected _costCenterService: CostCenterService,
      protected _shiftBlockService: ShiftBlockService,
      private _acuityService: AcuityService) {	
          super(_configService, _http, _costCenterService, _shiftBlockService);
    }
    
    protected getPreviousShiftBlockPromise(costCenter: CostCenter, shiftBlock: ShiftBlock, workflowTimeFacility: string) {
        return this._shiftBlockService.getPreviousShiftBlockForDate(costCenter.id, workflowTimeFacility);
    }

    protected async prepareShiftRecordDetails(costCenter: CostCenter, shiftBlock: ShiftBlock, shiftRecord: ShiftRecord, workflowTime: string): Promise<ShiftRecord> {
        let isAcuity = WorkflowPageUtil.hasAcuityConfiguration(costCenter);
        let isAcuityRooms = WorkflowPageUtil.hasAcuityWithRoomsConfiguration(costCenter);

        if (isAcuity) {
            return this.prepareAcuityShiftRecord(costCenter, shiftBlock, shiftRecord, workflowTime);
        } 
        else if (isAcuityRooms) {
            return this.prepareAcuityRoomsShiftRecord(costCenter, shiftBlock, shiftRecord, workflowTime);
        }
    }

    async getAcuityRoomsDetails(shiftRecord: ShiftRecord): Promise<AcuityRoomDetails>  {
        return await this._acuityService.getAcuityRoomDetails(shiftRecord.id); 
    }

    async getAcuityDetails(shiftRecord: ShiftRecord): Promise<AcuityDetails> {
        return await this._acuityService.getAcuityDetails(shiftRecord.id, shiftRecord.prevShiftRecordId);        
    }


    private async prepareAcuityShiftRecord(
        costCenter: CostCenter, 
        shiftBlock: ShiftBlock, 
        shiftRecord: ShiftRecord, 
        workflowTime: string): Promise<ShiftRecord> {
        let preparedShiftRecord = this.prepareShiftRecord(costCenter, shiftBlock, shiftRecord, workflowTime);

        preparedShiftRecord.patientCensusRecord = new PatientCensusRecord();
        
        let details = await this.getAcuityDetails(preparedShiftRecord);
        
        preparedShiftRecord.acuityCensusRecords = details.censusRecords;        
        preparedShiftRecord.measureRecords = details.measures;
        preparedShiftRecord.staffingPlans = details.staffingPlans;
        preparedShiftRecord.varianceReasonRecords = details.varianceReasons;

        if (preparedShiftRecord.prevShiftRecord && details.previousCensusRecords) {
            preparedShiftRecord.prevShiftRecord.acuityCensusRecords = details.previousCensusRecords;
        }

        return preparedShiftRecord;
    }

    private async prepareAcuityRoomsShiftRecord(
      costCenter: CostCenter, 
      shiftBlock: ShiftBlock, 
      shiftRecord: ShiftRecord, 
      workflowTime: string): Promise<ShiftRecord> {
      let preparedShiftRecord = this.prepareShiftRecord(costCenter, shiftBlock, shiftRecord, workflowTime);

      let details = await this.getAcuityRoomsDetails(preparedShiftRecord);

      preparedShiftRecord.acuityCensusRecords = details.censusRecords
      preparedShiftRecord.measureRecords = details.measures;
      preparedShiftRecord.staffingPlans = details.staffingPlans;
      preparedShiftRecord.varianceReasonRecords = details.varianceReasons;
      preparedShiftRecord.roomAcuityRecords = details.roomAcuityRecords;

      return preparedShiftRecord;
  }

    
}
